import React, { useState } from 'react';

const TextArea = ({ title, className = '', onChange, value = '', name }) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <div className={`relative mb-5 min-w-32 flex-grow ${className}`} dir="rtl">
      <textarea
          name={name}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(value !== '')}
          className="w-full px-4 pt-5 pb-2 text-md bg-transparent border border-gray-400 rounded-md shadow appearance-none focus:outline-light-primary focus:border-blue-500 transition-all peer min-h-20 text-right"
      />
            <label
                className={`absolute right-4 text-gray-500 text-md transition-all bg-light-bg px-1 ${
                    isFocused || value ? '-top-2 text-xs text-blue-500' : 'top-4'
                }`}
            >
                {title}
            </label>
        </div>
    );
};

export default TextArea;
